import * as ResourceTypes from './ResourceTypes';
import PixelReporter from './PixelReporter';
import JavascriptReporter from './JavascriptReporter';

export const report = list => Promise.all(list.map(reportEvent));
export const reportEvent = event => reportFormatFactory(event).run();

export const reportFormatFactory = config => {
  switch(config.format) {
    case ResourceTypes.IMAGE_RESOURCE:
      return new PixelReporter(config.src, config.whitelisted);
      break;
    case ResourceTypes.JAVASCRIPT_RESOURCE:
      return new JavascriptReporter(config.src, config.whitelisted);
      break;
  }
};


// WEBPACK FOOTER //
// ./src/Services/Reporting/Reporters.js